import { render, staticRenderFns } from "./auth-layout.component.vue?vue&type=template&id=06f7f890&scoped=true"
import script from "./auth-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./auth-layout.component.ts?vue&type=script&lang=ts&external"
import style0 from "./auth-layout.component.vue?vue&type=style&index=0&id=06f7f890&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f7f890",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f7f890')) {
      api.createRecord('06f7f890', component.options)
    } else {
      api.reload('06f7f890', component.options)
    }
    module.hot.accept("./auth-layout.component.vue?vue&type=template&id=06f7f890&scoped=true", function () {
      api.rerender('06f7f890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/auth-layout/auth-layout.component.vue"
export default component.exports